<div class="edit-amount-dialog">
  <header class="dialog-header">
    <div class="dialog-header__icon" aria-hidden="true">
      <mat-icon>confirmation_number</mat-icon>
    </div>
    <div class="dialog-header__text">
      <span class="dialog-header__eyebrow">Ticketería</span>
      <h2 mat-dialog-title>Editar monto del ticket</h2>
      <p class="dialog-header__subtitle">
        Edición individual. El total del servicio lo recalcula el backend.
      </p>
      <p *ngIf="serviceName" class="dialog-header__context">
        {{ serviceName }}
      </p>
    </div>
  </header>

  <mat-dialog-content class="dialog-body" [formGroup]="form">
    <div class="meta-row">
      <div class="meta-stat">
        <span class="meta-stat__label">Moneda</span>
        <strong class="meta-stat__value">{{ currencyLabel }}</strong>
      </div>
      <div class="meta-stat" *ngIf="tipoCambio != null; else missingFx">
        <span class="meta-stat__label">Tipo de cambio</span>
        <strong class="meta-stat__value">{{ tipoCambio }}</strong>
      </div>
      <ng-template #missingFx>
        <div class="meta-stat meta-stat--warn">
          <span class="meta-stat__label">Tipo de cambio</span>
          <strong class="meta-stat__value">Sin TC</strong>
        </div>
      </ng-template>
      <div class="meta-stat" *ngIf="currentTotalLabel">
        <span class="meta-stat__label">Actual</span>
        <strong class="meta-stat__value">{{ currentTotalLabel }}</strong>
      </div>
    </div>

    <div *ngIf="saveError" class="alert alert--error" role="alert">
      <mat-icon>error_outline</mat-icon>
      <div>
        <strong>No se pudo guardar</strong>
        <span>{{ saveError }}</span>
      </div>
    </div>

    <div class="field-group">
      <div class="field-group__header">
        <label class="field-group__label" for="edit-ticket-amount">
          Nuevo monto del ticket
        </label>
        <span class="field-badge field-badge--required">Obligatorio</span>
      </div>

      <div
        class="amount-field"
        [class.amount-field--error]="!!amountError"
        [class.amount-field--disabled]="loading"
      >
        <span class="amount-field__prefix" aria-hidden="true">{{
          currencyPrefix
        }}</span>
        <input
          id="edit-ticket-amount"
          type="text"
          inputmode="decimal"
          formControlName="monto"
          class="amount-field__input"
          [attr.disabled]="loading ? true : null"
          placeholder="0.00"
          autocomplete="off"
          (input)="onNumberInput($event)"
        />
      </div>

      <p class="field-group__hint">
        Preview local (no es autoridad): el backend suma todos los tickets del
        servicio.
      </p>
      <p *ngIf="amountError" class="field-group__error">{{ amountError }}</p>
    </div>

    <div class="preview-card" *ngIf="form.value.monto">
      <div class="preview-card__row">
        <span>Otros tickets</span>
        <strong
          >{{ currencyPrefix }} {{ siblingTicketsSum | formatNumber }}</strong
        >
      </div>
      <div class="preview-card__row">
        <span>Total servicio estimado</span>
        <strong
          >{{ currencyPrefix }}
          {{ projectedServiceTotal | formatNumber }}</strong
        >
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      mat-stroked-button
      type="button"
      class="btn btn--ghost"
      (click)="onCancel()"
      [disabled]="loading"
    >
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="btn btn--primary"
      (click)="onSave()"
      [disabled]="!canSubmit"
    >
      <mat-progress-spinner
        *ngIf="loading"
        mode="indeterminate"
        diameter="18"
      ></mat-progress-spinner>
      <span *ngIf="!loading">Guardar monto</span>
    </button>
  </mat-dialog-actions>
</div>
